import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

interface TeamProfile {
  tenantId: string;
  memberCount: number;
  skillFrequency: Record<string, number>;
  identifiedGaps: string[];
  coverageMap: Record<string, number>;
}

export function useTeamProfile() {
  return useQuery({
    queryKey: ['team-profile'],
    queryFn: () => apiFetch<TeamProfile>('/team/profile')
  });
}

export function useRefreshTeamProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => apiFetch<TeamProfile>('/team/refresh', { method: 'POST' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['team-profile'] });
    }
  });
}

export type { TeamProfile };
